<div class="custom-container">
  <div class="py-70">
    <app-section-heading [sectionHeading]="breakdown.sectionHeading" />

    <div class="breakdown-cards-wrapper mt-45">
      <div class="breakdown-grid-template">
        <div
          class="card-container"
          [class.first-card]="
            breakdown.breakdownCardsRowOne.indexOf(card) === 0
          "
          *ngFor="let card of breakdown.breakdownCardsRowOne"
        >
          <p class="section-sub-title">{{ card.title }}</p>
          <p class="section-text mt-20">
            {{ card.description }}
          </p>

          <img
            *ngIf="card.image"
            [src]="card.image.src"
            [alt]="card.image.alt"
            class="position-absolute right-70 bottom-65"
          />
        </div>
      </div>

      <div class="breakdown-grid-template-reversed">
        <div
          class="card-container"
          *ngFor="let card of breakdown.breakdownCardsRowTwo"
        >
          <p class="section-sub-title">{{ card.title }}</p>
          <p class="section-text mt-20">
            {{ card.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
